/**
 * @fileoverview Shared module for utils.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Normalizes a URL path by removing hash, search params, and trailing slash.
 * E.g., "/documentation/build-emails/layers/" -> "/documentation/build-emails/layers"
 */
export function normalizePath(path?: string | null): string {
  if (!path) return '';
  const withoutQuery = path.split('?')[0] ?? '';
  const clean = (withoutQuery.split('#')[0] ?? '').trim();
  if (clean === '' || clean === '/') return '/';
  return clean.replace(/\/+$/, '');
}

/**
 * Checks if two paths are equivalent regardless of trailing slashes, queries, or hashes.
 */
export function isPathActive(currentPath?: string | null, targetPath?: string | null): boolean {
  return normalizePath(currentPath) === normalizePath(targetPath);
}

/**
 * Checks if currentPath is identical to parentPath or is a descendant of parentPath.
 */
export function isPathInSubtree(currentPath?: string | null, parentPath?: string | null): boolean {
  const normCurrent = normalizePath(currentPath);
  const normParent = normalizePath(parentPath);
  if (!normCurrent || !normParent) return false;
  if (normCurrent === normParent) return true;
  return normCurrent.startsWith(`${normParent}/`);
}
